// utilities/downloadUtils.ts
/**
 * Triggers a download of a Blob with the given filename.
 */
export function downloadBlobFile({ data, fileName }: { data: Blob; fileName: string }) {
	const url = window.URL.createObjectURL(data);
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
}

// Utility (place in a shared utils file)
export function dataUrlToBlob(dataUrl: string): Blob {
	const [meta, b64] = dataUrl.split(',');
	const mimeMatch = meta.match(/data:(.*?);base64/);
	const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
	const bin = atob(b64);
	const len = bin.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
	return new Blob([bytes], { type: mime });
}
